import React, { useState } from 'react';

/**
 * Küçük kare önizleme; kırık URL → children (ikon) gösterilir.
 */
export default function FeedEventThumb({ url, children, size = 'md', className = '' }) {
  const [bad, setBad] = useState(false);
  const dim =
    size === 'sm'
      ? 'h-11 w-11 sm:h-12 sm:w-12'
      : size === 'lg'
        ? 'h-16 w-16 sm:h-[4.5rem] sm:w-[4.5rem]'
        : 'h-14 w-14 sm:h-16 sm:w-16';

  return (
    <div
      className={`relative shrink-0 overflow-hidden rounded-xl border bg-black/55 ${dim} flex items-center justify-center ${className}`}
    >
      {url && !bad ? (
        <img
          src={url}
          alt=""
          className="h-full w-full object-cover"
          loading="lazy"
          decoding="async"
          onError={() => setBad(true)}
        />
      ) : (
        children
      )}
    </div>
  );
}
